module.exports = __webpack_public_path__ + "static/img/tab_active_4.4fa07d6b.png";